import React from 'react';
import { Col, Row } from 'antd';
import { agra, Amritsar, bangalore, chennai, Delhi, Goa, Hyderabad, Jaipur, kolkata, manali, Mumbai, Shimla } from '../../../utils/ImagePath';
import { useNavigate } from 'react-router-dom';
import dayjs from 'dayjs';

const PopularDestination = () => {

    const navigate = useNavigate();
    const dateFormat = 'MMM DD, YYYY';
    const today = dayjs().add(1, "day").format(dateFormat);
    const nextDay = dayjs().add(2, "day").format(dateFormat);

    const handleDestinationClick = (destination) => {
        localStorage.setItem("startDate", JSON.stringify(today));
        localStorage.setItem("endDate", JSON.stringify(nextDay));
        localStorage.setItem("selectedHotelCityName", JSON.stringify(destination));
        const formattedCityName = destination.cityName.toLowerCase().replace(/\s+/g, '-');
        const formattedCountryName = destination.countryName.toLowerCase().replace(/\s+/g, '-');
        const urlIdDynamic = `hotels-in-${formattedCityName}`;
        let formattedUrl = `/hotels-${formattedCountryName}/${urlIdDynamic}`
        localStorage.setItem("hotelSearchKey", JSON.stringify({
            'id': destination?.id,
            'name': destination?.name,
            'cityId': destination?.tboCityId,
            'state': destination?.state,
            'countryName': destination?.countryName,
            'countryId': destination?.countryId,
            'countryCode': destination?.tboCountryCode,
            'source': destination?.source,
            'tripjack_city_id': destination?.tripjack_city_id,
        }));
        navigate(formattedUrl);
    };


    return (
        <div>

            <section className="discount-area ptb-70">
                <div className="container">
                    <div className="section-title">
                        <div>
                            <h2>Popular Domestic Destinations </h2>
                            <span className="top-title">We have selected some best locations around the world for you.</span>
                        </div>
                        <a href="" className='d-none'>See All</a>
                    </div>
                    <Row gutter={20} className="justify-content-center">
                        <Col lg={6} md={12} sm={24} xs={24}>
                            <a className="discount-single-item text-decoration-none d-block"
                                style={{ height: "245px" }}
                                onClick={() => handleDestinationClick(
                                    {
                                        "id": "29212",
                                        "tboCityId": "144306",
                                        "tripjack_city_id": "699261",
                                        "tboCountryCode": "IN",
                                        "state": "Maharashtra",
                                        "countryName": "INDIA",
                                        "type": "CITY",
                                        "name": "MUMBAI",
                                        "cityName": "MUMBAI",
                                        "fullRegionName": "MUMBAI, MAHARASHTRA, INDIA",
                                        "countryId": "106",
                                        "source": "city"
                                    })}
                            >
                                <img loading="lazy" src={Mumbai} alt='Mumbai' height={245} width={'100%'} />
                                <div className="discount-single-content">
                                    <h3>Mumbai</h3>
                                    <span>Mumbai is known for its film industry and vibrant culture.</span>
                                </div>
                            </a>
                            <a className="discount-single-item text-decoration-none d-block"
                                style={{ height: "245px" }}
                                onClick={() =>
                                    handleDestinationClick(
                                        {
                                            "id": "29154",
                                            "tboCityId": "113128",
                                            "tripjack_city_id": "739947",
                                            "tboCountryCode": "IN",
                                            "state": "West Bengal",
                                            "countryName": "INDIA",
                                            "type": "CITY",
                                            "name": "KOLKATA",
                                            "cityName": "KOLKATA",
                                            "fullRegionName": "KOLKATA, WEST BENGAL, INDIA",
                                            "countryId": "106",
                                            "source": "city"
                                        }
                                    )
                                } >
                                <img loading="lazy" src={kolkata} alt='Kolkata' height={245} width={'100%'} />
                                <div className="discount-single-content">
                                    <h3>Kolkata</h3>
                                    <span>Kolkata, West Bengal's capital, is known for its history, culture, festivals, and architecture.</span>
                                </div>
                            </a>
                        </Col>
                        <Col lg={8} md={12} sm={24} xs={24}>
                            <a className="discount-single-item text-decoration-none d-block" style={{ height: "516px" }}
                                onClick={() => handleDestinationClick({
                                    "id": "29381",
                                    "tboCityId": "130443",
                                    "tripjack_city_id": "725862",
                                    "tboCountryCode": "IN",
                                    "state": "DELHI",
                                    "countryName": "India",
                                    "type": "CITY",
                                    "name": "Delhi",
                                    "cityName": "Delhi",
                                    "fullRegionName": "INDIA",
                                    "countryId": "106",
                                    "source": "city"
                                })}
                            >
                                <img loading="lazy" src={Delhi} alt='Delhi' height={516} width={'100%'} />

                                <div className="discount-single-content">
                                    <h3>Delhi</h3>
                                    <span>Delhi, India's capital, is known for its history, markets, and vibrant culture.</span>
                                </div>
                            </a>
                        </Col>
                        <Col lg={10} md={24} sm={24} xs={24}>
                            <a className="discount-single-item text-decoration-none d-block" style={{ height: "245px" }}
                                onClick={() => handleDestinationClick({
                                    "id": "28597",
                                    "tboCityId": "127343",
                                    "tripjack_city_id": "738801",
                                    "tboCountryCode": "IN",
                                    "state": "Tamil Nadu",
                                    "countryName": "INDIA",
                                    "type": "CITY",
                                    "name": "CHENNAI",
                                    "cityName": "CHENNAI",
                                    "fullRegionName": "CHENNAI, TAMIL NADU, INDIA",
                                    "countryId": "106",
                                    "source": "city"
                                })}
                            >
                                <img loading="lazy" src={chennai} alt='Chennai' height={245} width={'100%'} />
                                <div className="discount-single-content">
                                    <h3>Chennai</h3>
                                    <span>Chennai, Tamil Nadu’s capital, is known for its beaches, temples, culture, cuisine, and industries.</span>
                                </div>
                            </a>
                            <Row gutter={20}>
                                <Col lg={10} md={12} sm={24} xs={24} className="mb-4 mb-md-0">
                                    <a className="discount-single-item text-decoration-none d-block mb-0" style={{ height: "245px" }}
                                        onClick={() => handleDestinationClick({
                                            "id": "28874",
                                            "tboCityId": "145710",
                                            "tripjack_city_id": "739424",
                                            "tboCountryCode": "IN",
                                            "state": "Andra Pradesh",
                                            "countryName": "INDIA",
                                            "type": "CITY",
                                            "name": "HYDERABAD",
                                            "cityName": "HYDERABAD",
                                            "fullRegionName": "HYDERABAD, TELANGANA, INDIA",
                                            "countryId": "106",
                                            "source": "city"
                                        })}
                                    >
                                        <img loading="lazy" src={Hyderabad} alt='Hyderabad' height={245} width={'100%'} />
                                        <div className="discount-single-content">
                                            <h3>Hyderabad</h3>
                                            <span>Hyderabad is known for history, biryani, and tech.</span>
                                        </div>
                                    </a>
                                </Col>
                                <Col lg={14} md={12} sm={24} xs={24} className="mb-4 mb-md-0">
                                    <a className="discount-single-item objeit-fit-cover mb-0 text-decoration-none d-block" style={{ height: "245px" }}
                                        onClick={() => handleDestinationClick({
                                            "id": "29224",
                                            "tboCityId": "111124",
                                            "tripjack_city_id": "697302",
                                            "tboCountryCode": "IN",
                                            "state": "Karnataka",
                                            "countryName": "INDIA",
                                            "type": "CITY",
                                            "name": "BENGALURU",
                                            "cityName": "BENGALURU",
                                            "fullRegionName": "BENGALURU, KARNATAKA, INDIA",
                                            "countryId": "106",
                                            "source": "city"
                                        })}
                                    >
                                        <img loading="lazy" src={bangalore} alt='Bengaluru' height={245} width={'100%'} />
                                        <div className="discount-single-content">
                                            <h3>Bengaluru</h3>
                                            <span>Bengaluru, Karnataka’s capital, is known for its tech industry, gardens, and vibrant culture.</span>
                                        </div>
                                    </a>
                                </Col>
                            </Row>
                        </Col>
                    </Row>
                    <Row gutter={20} className="justify-content-center">
                        <Col lg={10} md={24} sm={24} xs={24}>
                            <a className="discount-single-item text-decoration-none d-block"
                                style={{ height: "245px" }}
                                onClick={() => handleDestinationClick({
                                    "id": "29311",
                                    "tboCityId": "101129",
                                    "tripjack_city_id": "740217",
                                    "tboCountryCode": "IN",
                                    "state": "Punjab",
                                    "countryName": "INDIA",
                                    "type": "CITY",
                                    "name": "AMRITSAR",
                                    "cityName": "AMRITSAR",
                                    "fullRegionName": "AMRITSAR, PUNJAB, INDIA",
                                    "countryId": "106",
                                    "source": "city"
                                })}
                            >
                                <img loading="lazy" src={Amritsar} alt='Amritsar' height={245} width={'100%'} />
                                <div className="discount-single-content">
                                    <h3>Amritsar</h3>
                                    <span>Amritsar known for the Golden Temple, vibrant culture, rich cuisine, agriculture, and festivals like Lohri and Vaisakhi.</span>
                                </div>
                            </a>
                            <Row gutter={20}>
                                <Col lg={10} md={12} sm={24} xs={24} className="mb-4 mb-lg-0">
                                    <a className="discount-single-item text-decoration-none d-block mb-0" style={{ height: "245px" }}
                                        onClick={() => handleDestinationClick({
                                            "id": "15086",
                                            "tboCityId": "126388",
                                            "tripjack_city_id": "656671",
                                            "tboCountryCode": "IN",
                                            "state": "Himachal pradesh",
                                            "countryName": "INDIA",
                                            "type": "CITY",
                                            "name": "MANALI",
                                            "cityName": "MANALI",
                                            "fullRegionName": "MANALI, HIMACHAL PRADESH, INDIA",
                                            "countryId": "106",
                                            "source": "city"
                                        })}

                                    >
                                        <img loading="lazy" src={manali} alt='Manali' height={245} width={'100%'} />

                                        <div className="discount-single-content">
                                            <h3>Manali</h3>
                                            <span>Manali is famous for snow, adventure, nature, and tranquility.</span>
                                        </div>
                                    </a>
                                </Col>
                                <Col lg={14} md={12} sm={24} xs={24} className="mb-4 mb-lg-0">
                                    <a className="discount-single-item objeit-fit-cover mb-0 text-decoration-none d-block"
                                        style={{ height: "245px" }}
                                        onClick={() => handleDestinationClick({
                                            "id": "28163",
                                            "tboCityId": "138673",
                                            "tripjack_city_id": "737971",
                                            "tboCountryCode": "IN",
                                            "state": "Himachal Pradesh",
                                            "countryName": "INDIA",
                                            "type": "CITY",
                                            "name": "SHIMLA",
                                            "cityName": "SHIMLA",
                                            "fullRegionName": "SHIMLA, HIMACHAL PRADESH, INDIA",
                                            "countryId": "106",
                                            "source": "city"
                                        })}>
                                        <img loading="lazy" src={Shimla} alt='Shimla' height={245} width={'100%'} />
                                        <div className="discount-single-content">
                                            <h3>Shimla</h3>
                                            <span>Shimla is known for its colonial architecture and scenic hill views.</span>

                                        </div>
                                    </a>
                                </Col>
                            </Row>
                        </Col>
                        <Col lg={8} md={12} sm={24} xs={24}>
                            <a className="discount-single-item text-decoration-none d-block mb-md-0"
                                style={{ height: "516px" }}
                                onClick={() => handleDestinationClick({
                                    "id": "29359",
                                    "tboCityId": "100589",
                                    "tripjack_city_id": "275216",
                                    "tboCountryCode": "IN",
                                    "state": "Uttar Pradesh",
                                    "countryName": "INDIA",
                                    "type": "CITY",
                                    "name": "AGRA",
                                    "cityName": "AGRA",
                                    "fullRegionName": "AGRA, UTTAR PRADESH, INDIA",
                                    "countryId": "106",
                                    "source": "city"
                                })}
                            >
                                <img loading="lazy" src={agra} alt='Agra' height={516} width={'100%'} />
                                <div className="discount-single-content">
                                    <h3>Agra</h3>
                                    <span>Agra, in Uttar Pradesh, is famous for the Taj Mahal, Agra Fort, Fatehpur Sikri, Mughal architecture, vibrant crafts, and history.</span>
                                </div>
                            </a>
                        </Col>
                        <Col lg={6} md={12} sm={24} xs={24}>
                            <a className="discount-single-item text-decoration-none d-block"
                                style={{ height: "245px" }}
                                onClick={() => handleDestinationClick({
                                    "id": "28824",
                                    "tboCityId": "122175",
                                    "tripjack_city_id": "739239",
                                    "tboCountryCode": "IN",
                                    "state": "Rajasthan",
                                    "countryName": "INDIA",
                                    "type": "CITY",
                                    "name": "JAIPUR",
                                    "cityName": "JAIPUR",
                                    "fullRegionName": "JAIPUR, RAJASTHAN, INDIA",
                                    "countryId": "106",
                                    "source": "city"
                                })}
                            >
                                <img loading="lazy" src={Jaipur} alt='Jaipur' height={245} width={'100%'} />
                                <div className="discount-single-content">
                                    <h3>Jaipur</h3>
                                    <span>Jaipur, the "Pink City," is famous for its palaces, forts, vibrant markets, and rich heritage.</span>
                                </div>
                            </a>
                            <a className="discount-single-item text-decoration-none d-block mb-md-0" style={{ height: "245px" }}
                                onClick={() => handleDestinationClick(
                                    {
                                        "id": "19994",
                                        "tboCityId": "119805",
                                        "tripjack_city_id": "699356",
                                        "tboCountryCode": "IN",
                                        "state": "GOA",
                                        "countryName": "INDIA",
                                        "type": "PROVINCE_STATE",
                                        "name": "GOA",
                                        "cityName": "GOA",
                                        "fullRegionName": "GOA, INDIA",
                                        "countryId": "106",
                                        "source": "city"
                                    }
                                )}
                            >
                                <img loading="lazy" src={Goa} alt='Goa' height={245} width={'100%'} />
                                <div className="discount-single-content">
                                    <h3>Goa</h3>
                                    <span>Goa is famous for its beaches, nightlife, and Portuguese heritage.</span>
                                </div>
                            </a>
                        </Col>
                    </Row>

                </div>
            </section >

        </div >
    )
}

export default PopularDestination